export const navigateIntoSections = (sectionId, offset, callback) => {
    var section = document.getElementById(sectionId);
    var scrollOffset = section.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
}